import {
  EmptyState,
  EmptyStateContainer,
} from 'module/ui/components/atoms/empty-state/empty-state';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faPage } from '@fortawesome/pro-regular-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

type PeoplePageTemplatesEmptyStateProps = {
  onPrimaryAction: VoidFunction;
};
export const PeoplePageTemplatesNoSearchMatchState = ({
  onPrimaryAction,
}: PeoplePageTemplatesEmptyStateProps) => {
  return (
    <EmptyStateContainer>
      <EmptyState
        image={
          <FontAwesomeIcon
            icon={faPage}
            size={50}
            iconSize={40}
            color="transparent"
          />
        }
        title={
          <FormattedMessage id="people_page_templates.empty_state.no_search_results.title" />
        }
        message={
          <FormattedMessage id="people_page_templates.empty_state.no_search_results.message" />
        }
        primaryCTA={
          <EmptyState.CallToAction.Primary onClick={onPrimaryAction}>
            <FormattedMessage id="clear_search" />
          </EmptyState.CallToAction.Primary>
        }
      />
    </EmptyStateContainer>
  );
};
export const PeoplePageTemplatesNoTemplatesState = ({
  onPrimaryAction,
}: PeoplePageTemplatesEmptyStateProps) => {
  return (
    <EmptyStateContainer>
      <EmptyState
        image={
          <FontAwesomeIcon
            icon={faPage}
            size={50}
            iconSize={40}
            color="transparent"
          />
        }
        title={
          <FormattedMessage id="people_page_templates.empty_state.no_templates.title" />
        }
        message={
          <FormattedMessage id="people_page_templates.empty_state.no_templates.message" />
        }
        primaryCTA={
          <EmptyState.CallToAction.Primary
            onClick={onPrimaryAction}
            leftIcon={<FontAwesomeIcon icon={faPlus} size={12} />}
          >
            <FormattedMessage id="new_template" />
          </EmptyState.CallToAction.Primary>
        }
      />
    </EmptyStateContainer>
  );
};
